import moment from 'moment';

import type { Voucher, VouchersRequestData } from 'api/vouchers/types';
import type { State } from '../context';

export const getRequestObject = (state: State) => {
  const { vouchers, creditCard } = state;

  const { name, number, expiry, cvc } = creditCard;
  const [expMonth, expYear] = expiry.split('/');

  const [{ creator_email, creator_name, currency }] = vouchers;

  const requestObj: VouchersRequestData = {
    creator_email,
    creator_name,
    credit_card: {
      cvc,
      name,
      number,
      exp_month: expMonth,
      exp_year: expYear,
    },
    currency,
    vouchers: vouchers.map(voucher => {
      const returnedVoucher: Voucher = {
        amount: Number(voucher.amount.replace(',', '')),
        currency: voucher.currency,
        recipient_email: voucher.recipient_email,
        send_at: moment(voucher.send_date).unix(),
        custom_gift_card_id: voucher.custom_gift_card_id,
      };

      if (voucher.self_send) {
        returnedVoucher.recipient_email = creator_email;
      }

      if (voucher.message) {
        returnedVoucher.message = voucher.message;
      }

      if (voucher.recipient_name) {
        returnedVoucher.recipient_name = voucher.recipient_name;
      }

      return returnedVoucher;
    }),
  };

  return requestObj;
};
